import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

import type { ListVariant } from '../list.context';

export const root = css`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
`;

export const gap = (theme: Theme) => css`
  column-gap: ${theme.spacing[12]};

  ${breakpoint.down('sm')} {
    column-gap: ${theme.spacing[8]};
  }
`;

export const iconWrapper: Record<ListVariant, (theme: Theme) => SerializedStyles> = {
  medium: (theme: Theme) => css`
    line-height: 0;
    width: ${theme.spacing[24]};
    height: ${theme.spacing[24]};

    ${breakpoint.down('sm')} {
      width: ${theme.spacing[20]};
      height: ${theme.spacing[20]};
    }
  `,
  small: (theme: Theme) => css`
    line-height: 0;
    width: ${theme.spacing[20]};
    height: ${theme.spacing[20]};

    ${breakpoint.down('sm')} {
      width: ${theme.spacing[16]};
      height: ${theme.spacing[16]};
    }
  `,
};
